import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import http from "../http";
const initialState = {
    //----home-----
    data: null,//某个景点所有业态内容
    filterData: null,//某景点下的分类业态

    //----yetai-----
    dataSearch: [],//搜索返回所有业态内容
    currentYetaiDetail: null,//某个具体的业态
    loading: false,
    loading_search: false,
    error: null,
    error_search: null,
    currentPage: 1,
    type0: '',
    type1: '',
    type2: '',
    orderBy: '',
    hasMore: true,
}

//某个景点（id)的业态
export const fetchYetai = createAsyncThunk('yetai', async (requestData, thunkAPI) => {
    try {
        const response = await http.post('/v1/business/' + requestData.id);
        return response.data; // 返回获取到的数据
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data); // 返回错误信息
    }
});

//搜索的业态
export const fetchYetaiSearch = createAsyncThunk('yetaiSearch', async (requestData, thunkAPI) => {
    try {
        const state = thunkAPI.getState().yetai;
        // if (!state.hasMore) {
        //     return;
        // }


        if (!requestData.page) {
            requestData.page = state.currentPage + 1;
        }

        requestData.size = 10;
        requestData.district_id = state.type0;
        requestData.county_id = state.type1;
        requestData.city_id = state.type2;
        requestData.orderby = state.orderBy?state.orderBy:null;

        requestData.latitude = state.lat;
        requestData.longitude = state.lng;

        const response = await http.post('/v1/business_search', requestData);
        console.log("requestData:::",response)

        return response.data; // 返回获取到的数据
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data); // 返回错误信息
    }
});

const slice = createSlice({
    name: 'yetai',
    initialState,
    reducers: {
        //当前景点下的分类(home下使用)
        YetaiFilterByType(state, action) {
            if (state.data) {
                state.filterData = state.data.filter(e => {
                    return e.stype == action.payload
                })
            }
        },

        //清除SearchData，防闪烁
        ClearSearchData(state, action) {
            state.length = 0;
            state.dataSearch = [];
        },
        UpdateCurrentYetai(state, action) {
            state.currentYetaiDetail = action.payload;
        },
        UpdateCurrentPage(state, action) {
            state.currentPage = action.payload;
        },
        // UpdateSortBy(state, action) {
        //     if (action.payload == "like") {
        //         if (state.dataSearch) {
        //             state.dataSearch = state.dataSearch.sort((a, b) => {
        //                 return b.score - a.score;
        //             });
        //             console.log("state.dataSearch:",state.dataSearch);
        //         }
        //         else {
        //             console.log('没有数据');
        //         }
        //     }
        //     else if (action.payload == "near") {
        //         console.log(window.geolocation)



        //         if (state.dataSearch) {


        //             // state.dataSearch = state.dataSearch.sort((a, b) => {

        //             // });
        //         }
        //         else {
        //             console.log('没有数据');
        //         }
        //     }
        // },
        UpdateDisCityCountroy(state, action) {
            state.type0 = action.payload.type0;
            state.type1 = action.payload.type1;
            state.type2 = action.payload.type2;
        },
        UpdateOrderBy(state, action) {
            console.log("action.payload:", action.payload);
            state.orderBy = action.payload.sortBy;
            state.lat = action.payload.lat;
            state.lng = action.payload.lng;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchYetai.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchYetai.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.isSuccess == 1) {
                    state.data = action.payload.item;
                }
                else {
                    state.data = null;
                }

            })
            .addCase(fetchYetai.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchYetaiSearch.pending, (state, action) => {
                state.loading_search = true;
                state.error_search = null;
            })
            .addCase(fetchYetaiSearch.fulfilled, (state, action) => {
                if (action.payload.isSuccess == 1) {
                    if (action.payload.item.business) {
                        let combinedData = [...state.dataSearch, ...action.payload.item.business];
                        state.dataSearch = Array.from(new Set(combinedData.map(item => item.id)))
                            .map(id => combinedData.find(item => item.id === id));

                        state.currentPage = action.payload.item.currentPage;
                        console.log("2::::::::::", state.currentPage)

                        if (state.currentPage >= action.payload.item.lastPage) {
                            state.hasMore = false;
                        }
                        else {
                            state.hasMore = true;
                        }
                    }

                }
                else {
                    state.dataSearch.length = 0;
                    state.dataSearch = [];
                }

                state.loading_search = false;


            })
            .addCase(fetchYetaiSearch.rejected, (state, action) => {
                state.loading_search = false;
                state.error_search = action.payload;
            })
    }
})

export const { YetaiFilterByType, UpdateOrderBy, ClearSearchData,UpdateCurrentPage, UpdateCurrentYetai, UpdateDisCityCountroy } = slice.actions

export default slice.reducer